import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

interface UsageMetricsProps {
  callsThisWeek: number
  lovedOneId: string
  className?: string
}

/**
 * UsageMetrics component displays weekly call count
 * and a link to view full activity history.
 */
export function UsageMetrics({ callsThisWeek, lovedOneId, className }: UsageMetricsProps) {
  const { t } = useTranslation()

  const callLabel = callsThisWeek === 1 ? t('dashboard.callThisWeek') : t('dashboard.callsThisWeek')

  return (
    <div className={`usage-metrics ${className || ''}`}>
      <div className="usage-metrics-row">
        <span className="usage-metrics-text">
          <span className="usage-metrics-number">{callsThisWeek}</span>{' '}
          <span className="usage-metrics-label">{callLabel}</span>
        </span>
        <Link to={`/dashboard/${lovedOneId}/activity`} className="usage-metrics-link">
          {t('dashboard.viewActivity')} →
        </Link>
      </div>
      <style>{styles}</style>
    </div>
  )
}

const styles = `
  .usage-metrics {
    background-color: #fff;
    border-radius: 12px;
    padding: 1rem 1.25rem;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  }

  .usage-metrics-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 1rem;
  }

  .usage-metrics-text {
    white-space: nowrap;
  }

  .usage-metrics-number {
    font-size: 1.5rem;
    font-weight: 700;
    color: #1a1a1a;
  }

  .usage-metrics-label {
    font-size: 0.9rem;
    color: #666;
  }

  .usage-metrics-link {
    color: #0066cc;
    text-decoration: none;
    font-size: 14px;
    font-weight: 500;
    min-height: 44px;
    display: flex;
    align-items: center;
    padding: 0.5rem;
    white-space: nowrap;
  }

  .usage-metrics-link:hover {
    text-decoration: underline;
  }
`
